import { Content } from "./ContentBase";

export function CreateContentText(v:string|number|object,setContent:(newContent:Node)=>void):Content {
  let ctNode=document.createTextNode(v.toString());
  setContent(ctNode);
  return {
    Update:newV=>{
        if(newV!==v) {
          v=newV;
          ctNode.data=newV.toString();
        }
      },
    Unload:()=>{},
    MatchForUpdate:v=>true
  }
}